import { Hours } from '../features/schedule/types';

export const EMPTY_SUMMARY_HOURS: Hours = {
    billed: 0,
    totalHours: 0,
    approved: 0,
    planned: 0
};
